import type React from "react";
import { useParams } from "react-router-dom";

const EventFormPage: React.FC = () => {
	const { eventId } = useParams<{ eventId?: string }>();
	const isEditing = !!eventId;

	return (
		<div className="space-y-6">
			<h1 className="text-3xl font-bold">
				{isEditing ? "イベント編集" : "新規イベント作成"}
			</h1>
			<div className="bg-white p-6 rounded-lg shadow">
				{/* イベント作成/編集フォームをここに配置 */}
			</div>
		</div>
	);
};

export default EventFormPage;
